import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { api, ErrorResponse } from "@/utils/api";

const removeMember = async (id: string): Promise<void> => {
  await api.delete(`/members/${id}`);
};

export const useRemoveMember = (
  options: Omit<UseMutationOptions<void, ErrorResponse, string, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<void, ErrorResponse, string, unknown>({
    mutationFn: removeMember,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["members"]
      })
    },
    ...options
  });
};
